import { Location } from '@angular/common';
// Angular modules.
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ZkNotificationService } from '@zenklub/ng-ui';
// Zenklub enums.
import { EMobileMode } from 'app/enums/mobilemode.enum';
// Zenklub enums.
import { ESidebarMode } from 'app/enums/sidebarmode.enum';
// Zenklub interfaces.
import { IDay } from 'app/interfaces/calendar.interface';
import {
	AppointmentSidebarFrom,
	ISidebar,
} from 'app/interfaces/sidebar.interface';
import { AvailabilitiesService } from 'app/services/availabilities.service';
// Zenklub services.
import { CalendarService } from 'app/services/calendar.service';
import { DateTimeService } from 'app/services/datetime.service';
import { EventsService } from 'app/services/events.service';
import { GlobalService } from 'app/services/global.service';
import { GoogleCalendarService } from 'app/services/google-calendar.service';
import { NotificationsService } from 'app/services/notifications.service';
import { SearchService } from 'app/services/search.service';
import { UserService } from 'app/services/user.service';
import { enterAnimation } from 'app/utils/animations.util';
import * as $ from 'jquery';
import { DateTime } from 'luxon';
import { AppointmentSidebarService } from 'modules/appointments/services/appointment-sidebar.service';
import { PromptuarySidebarService } from 'modules/promptuary/services/sidebar/promptuary-sidebar.service';
import * as moment from 'moment-timezone';
// Third-party modules.
//TODO:  selectItem is deprecated and remove in v10
//import { SelectItem } from 'primeng/primeng';
import { ReplaySubject } from 'rxjs';

@Component({
	selector: 'app-calendar',
	templateUrl: './calendar.component.html',
	styleUrls: ['./calendar.component.scss'],
	animations: [enterAnimation],
	providers: [CalendarService, GlobalService, GoogleCalendarService],
})
export class CalendarComponent implements OnInit {
	// Inputs.
	@Input() visibilityChecked = false;
	@Input() isVisible = false;
	// Outputs.
	@Output() changeVisibleStatus: EventEmitter<boolean> =
		new EventEmitter<boolean>();
	// Dates.
	activeDate: IDay;
	todayDate: IDay;
	visibleCalendar: IDay;
	// Calendar mode.
	selectedMode: string;
	calendarModes = [] as any;
	// Calendar data.
	currentTimezone: string;
	calendarLabels: any;
	startWeekDate: Date;
	// Sidebar data.
	activeSidebar: ISidebar;
	sidebarVisible: string;
	modalVisible: ESidebarMode;
	// Filter data.
	mainSearch: any;
	searchResult: any[] = [];
	searchValue: string;
	// Window data.
	innerHeight: number;
	innerWidth: number;
	calendarHeight: number;
	// Status.
	firstCall = true;
	forceRefreshEvents = false;
	isMobile = false;
	// Mobile related.
	mobileFixedMode = false;
	mobileMode: EMobileMode;
	mobileForcedDetails = false;
	addAddress = 'appointments';
	routeState;
	professionalId = null;
	avaibilities = [];
	// Refresh profile Completion
	public resetProfileCompletion: ReplaySubject<boolean> =
		new ReplaySubject<boolean>();
	public showHideDetails: ReplaySubject<boolean> = new ReplaySubject<boolean>();

	welcomeModalOpen = false;
	viewedWelcomeModal = JSON.parse(localStorage.getItem('viewedWelcomeModal'));

	// Constructor method.
	constructor(
		protected calendar: CalendarService,
		protected dateTime: DateTimeService,
		protected events: EventsService,
		protected global: GlobalService,
		protected location: Location,
		protected notifications: NotificationsService,
		protected ZkNotification: ZkNotificationService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected translate: TranslateService,
		protected search: SearchService,
		protected user: UserService,
		protected availabilitiesService: AvailabilitiesService,
		protected gCalendar: GoogleCalendarService,
		public sidebarService: AppointmentSidebarService,
		public promptuarySidebarService: PromptuarySidebarService
	) {
		this.routeState = this.router.getCurrentNavigation()?.extras?.state;

		// Get window size.
		this.innerHeight =
			document.documentElement.clientHeight || window.screen.height;
		this.innerWidth =
			document.documentElement.clientWidth || window.screen.width;
		this.resetProfileCompletion.next(true);
	}

	// On init.
	ngOnInit() {
		this.user.getProfileData().then((res) => {
			this.professionalId = res.id;
		});

		this.availabilitiesService
			.getAll()
			.toPromise()
			.then((res) => {
				this.avaibilities = res;
			});
		// Determine calendar modes and labels.
		this.translate
			.get([
				'CALENDAR.MODES.MONTH',
				'CALENDAR.MODES.WEEK',
				'CALENDAR.MODES.DAY',
				'CALENDAR.MONTHS',
				'CALENDAR.WEEKDAYS',
			])
			.subscribe((res) => {
				// Verify if is a mobile device.
				this.isMobile = this.global.isMobileDevice();
				// Clear search.
				this.searchValue = null;
				if (this.isMobile && this.location.isCurrentPathEqualTo('/search')) {
					this.mobileMode = EMobileMode.Search;
					this.searchValue = localStorage.getItem('zksearch') || '';
				}
				// Calendar modes.
				this.calendarModes = [];
				this.calendarModes.push({
					label: res['CALENDAR.MODES.MONTH'],
					value: 'Month',
				});
				this.calendarModes.push({
					label: res['CALENDAR.MODES.WEEK'],
					value: 'Week',
				});
				this.calendarModes.push({
					label: res['CALENDAR.MODES.DAY'],
					value: 'Day',
				});
				const lastCalMode: any = JSON.parse(localStorage.getItem('zkcal'));
				// Calendar labels.
				const cMon: any = { ...res['CALENDAR.MONTHS'] };
				const cWee: any = { ...res['CALENDAR.WEEKDAYS'] };

				this.calendarLabels = {
					firstDayOfWeek: 0,
					dayNames: [
						cWee.SUN.SHORT,
						cWee.MON.SHORT,
						cWee.TUE.SHORT,
						cWee.WED.SHORT,
						cWee.THU.SHORT,
						cWee.FRI.SHORT,
						cWee.SAT.SHORT,
					],
					dayNamesShort: [
						cWee.SUN.ABB,
						cWee.MON.ABB,
						cWee.TUE.ABB,
						cWee.WED.ABB,
						cWee.THU.ABB,
						cWee.FRI.ABB,
						cWee.SAT.ABB,
					],
					monthNames: [
						cMon.JAN.FULL,
						cMon.FEB.FULL,
						cMon.MAR.FULL,
						cMon.APR.FULL,
						cMon.MAY.FULL,
						cMon.JUN.FULL,
						cMon.JUL.FULL,
						cMon.AUG.FULL,
						cMon.SEP.FULL,
						cMon.OCT.FULL,
						cMon.NOV.FULL,
						cMon.DEC.FULL,
					],
					monthNamesShort: [
						cMon.JAN.ABB,
						cMon.FEB.ABB,
						cMon.MAR.ABB,
						cMon.APR.ABB,
						cMon.MAY.ABB,
						cMon.JUN.ABB,
						cMon.JUL.ABB,
						cMon.AUG.ABB,
						cMon.SEP.ABB,
						cMon.OCT.ABB,
						cMon.NOV.ABB,
						cMon.DEC.ABB,
					],
				};
				// Get current time zone info.
				this.currentTimezone = this.dateTime.getBrowserTimezone();

				// Build active date.
				if (this.isMobile) {
					if (history.state && history.state.activeDate) {
						this.mobileForcedDetails = true;
						this.activeDate = history.state.activeDate as IDay;
						if (!this.visibleCalendar) {
							this.newVisibleMonth(this.activeDate.date);
						}
					} else {
						this.buildActiveDate();
					}
				} else {
					this.buildActiveDate();
				}
				// Update today.
				this.todayDate = this.activeDate;
				// Active sidebar.
				this.activeSidebar = {
					date: this.activeDate.date,
					id: null,
					mode: ESidebarMode.Appointments,
				};
				this.changeActiveSidebar(this.activeSidebar);
				// Update calendar data (last mode and last date).
				this.selectedMode =
					lastCalMode && lastCalMode.mode ? lastCalMode.mode : 'Week';
				this.storeCalendarData(this.selectedMode, this.activeDate.date);
				// Change mobile mode.
				if (this.isMobile && !this.mobileMode) {
					this.mobileMode = this.mobileForcedDetails
						? EMobileMode.Details
						: EMobileMode.Calendar;
				}
				// Subscription for new show event order.
				this.notifications.getEventToShowDetails().subscribe((eventId) => {
					// Active sidebar.
					this.activeSidebar = {
						date: new Date(),
						id: eventId,
						mode: ESidebarMode.Details,
					};
					this.changeActiveSidebar(this.activeSidebar);
				});
			});

		this.route.queryParams.subscribe((params) => {
			const { appointmentId, code: calendarIntegrationCode, scope } = params;

			if (appointmentId) {
				this.events.getEvent(appointmentId).then((data) => {
					this.activeSidebar = {
						date: new Date(),
						id: data.id,
						mode: ESidebarMode.Details,
						type: 'to-confirm',
					};
					this.changeActiveSidebar(this.activeSidebar);
				});
			}

			if (calendarIntegrationCode && scope) {
				this.gCalendar
					.saveIntegration(calendarIntegrationCode)
					.subscribe(() => {
						window.close();
					});
			}
		});

		// Resize window elements.
		this.positionCalendarHeader(true);
		// Reset positions on window resize.
		window.addEventListener('resize', () => {
			this.positionCalendarHeader();
		});

		if (this.viewedWelcomeModal !== null && !this.viewedWelcomeModal) {
			const createdAt = new Date(this.user.getUserLocal().createdAt).getTime();
			const now = new Date().getTime();
			this.welcomeModalOpen = now - createdAt <= 600000; // 600000 == 10 Minutes
		}
	}

	// Generate default activeDate.
	public buildActiveDate(date?: Date): void {
		// Current data.
		const today: Date = date || new Date();
		const month: number = today.getMonth();
		const weekday: number = today.getDay();
		// Build active date.
		this.activeDate = {
			date: today,
			day: today.getDate(),
			month: month + 1,
			monthFullName: this.calendarLabels.monthNames[month],
			monthShortName: this.calendarLabels.monthNamesShort[month],
			weekDay: weekday,
			weekDayAbbName: this.calendarLabels.dayNamesShort[weekday],
			weekDayFullName: this.calendarLabels.dayNames[weekday],
			weekDayShortName: this.calendarLabels.dayNamesShort[weekday],
			year: today.getFullYear(),
		};

		if (!this.visibleCalendar) {
			this.newVisibleMonth(today);
		}
	}

	// Set new visible month (multiMonth mode only).
	public newVisibleMonth(date?: Date): void {
		// Current data.
		const curDay: Date = date || new Date();
		const month: number = curDay.getMonth();
		const weekday: number = curDay.getDay();
		// Build active date.
		this.visibleCalendar = {
			date: curDay,
			day: curDay.getDate(),
			month: month + 1,
			monthFullName: this.calendarLabels.monthNames[month],
			monthShortName: this.calendarLabels.monthNamesShort[month],
			weekDay: weekday,
			weekDayAbbName: this.calendarLabels.dayNamesShort[weekday],
			weekDayFullName: this.calendarLabels.dayNames[weekday],
			weekDayShortName: this.calendarLabels.dayNamesShort[weekday],
			year: curDay.getFullYear(),
		};
	}

	// Main search filter.
	public searchFilter(event: any): void {
		this.searchResult = [];

		const searchResult: any = [];
		const trimName: string = event.query ? event.query.trim() : '';
		const search = this.getBoundariesDates();
		// Search on events collection.
		this.events.filterClientsOnEvents(trimName, search).then((r) => {
			if (r && r.length > 0) {
				searchResult.push(r);
			}
			this.events.filterEvents(searchResult).then((res) => {
				res.forEach((ev) => {
					const evDate: Date = new Date(ev.day);
					const evShowDate: string = this.dateTime.getStringDate(evDate, '/');
					const evHours: string = this.dateTime.getHourString(
						evDate.getHours(),
						evDate.getMinutes()
					);
					const evName: string = ev.userName;
					const evFormated: string =
						evShowDate + ' ' + evHours + ' - ' + evName;
					const item: Record<string, any> = {
						id: ev.id,
						userId: ev.profileId,
						date: evDate,
						showDate: evShowDate,
						hours: evHours,
						userName: evName,
						formated: evFormated,
					};
					// Verify if client already exists on result list.
					const exists = this.searchResult.some((x) => x.id === ev.id);
					if (!exists) {
						this.searchResult.push(item);
					}
				});
			});
		});
	}

	// Show selected filter.
	public filterSelected(item?: any): void {
		item = item || this.mainSearch;
		if (item && item.id) {
			const newSidebar: ISidebar = {
				date: item.date,
				id: item.id,
				hour: item.hours,
				mode: ESidebarMode.Details,
			};
			this.changeActiveSidebar(newSidebar);
		}
	}

	// Search filter.
	public filterSingle(): void {}

	// Save last calendar mode and data.
	protected storeCalendarData(mode: string, date: Date): void {
		localStorage.setItem('zkcal', JSON.stringify({ mode: mode, date: date }));
	}

	// Create a new event.
	public createNewEvent(sb?: ISidebar): void {
		if (sb) {
			this.activeSidebar = sb;
			this.activeSidebar.mode = ESidebarMode.New;
		} else {
			this.activeSidebar = {
				mode: ESidebarMode.New,
				date: new Date(),
				contactId: null,
				from: AppointmentSidebarFrom.HOME,
			};
		}
		this.changeActiveSidebar(this.activeSidebar);
	}

	// Change calendar mode.
	public changeCalendarMode(mode?: string): void {
		this.selectedMode = mode;
		this.buildActiveDate(new Date());
		this.firstCall = true;
		this.storeCalendarData(mode || this.selectedMode, this.activeDate.date);
	}

	// Change sidebar content.
	async changeActiveSidebar(sidebar: ISidebar): Promise<void> {
		this.activeSidebar = {
			...sidebar,
			time: sidebar.hour
				? this.getTimeByString(sidebar.date, sidebar.hour)
				: null,
			id: sidebar.id ?? null,
			contactId: sidebar.contactId ?? null,
		};

		this.sidebarVisible = 'Appointments';
		this.modalVisible = sidebar.mode;

		this.showHideDetails.next(
			this.sidebarVisible !== 'Appointments' || !this.sidebarVisible
		);
		if (
			this.activeSidebar.mode === ESidebarMode.New ||
			this.activeSidebar.mode === ESidebarMode.Edit
		) {
			await this.sidebarService.setSidebar(true, this.activeSidebar);
		}
	}

	public onCloseSidebar() {
		this.activeSidebar = {
			mode: ESidebarMode.New,
			date: new Date(),
			contactId: null,
		};
	}

	public getTimeByString(date, hour) {
		const _date = DateTime.fromJSDate(date);
		const _hour = DateTime.fromFormat(hour, 'HH:mm');

		_date.set({ hour: _hour.hour, minute: _hour.minute, second: 0 });
		return _date.toJSDate();
	}

	// Toggle mobile mode (fixed on/off).
	public toggleMobileMode(status: boolean): void {
		this.mobileFixedMode = status;
	}

	// Force to refresh local events.
	public forceToRefreshEvents(force: boolean) {
		this.activeSidebar.mode = ESidebarMode.Appointments;
		this.activeSidebar.date = new Date();
		const search = this.getBoundariesDates();

		if (force) {
			this.events.clearEventsCache();
		}

		this.availabilitiesService.updateLocalBusySlots();
		this.events.updateLocalEvents(search).then(() => {
			this.forceRefreshEvents = force;
		});
	}

	// Reschedule.
	public reschedule(sb: ISidebar): void {
		sb.mode = ESidebarMode.Edit;
		this.changeActiveSidebar(sb);
	}

	// Change calendar height based on screen size and its free vertical space.
	public changeCalendarHeight(event?: any, count = 0): void {
		const elNavbar: JQuery = $('#navbar');
		const elCalendar: JQuery = $('#calendar-container');
		const elCalScroll: JQuery = $('#calendar-scroll-container');
		const elSidebar: JQuery = $('#calendar-sidebar');
		if (count > 0 && elCalScroll.length > 0) {
			const navHeight: number = elNavbar.height();
			const calHeight: number = elCalendar.height();
			const scrHeight: number = elCalScroll.height();
			const sidHeight: number = elSidebar.height();
			const minScrollHeight: number = this.innerHeight - navHeight - 220;
			if (calHeight < sidHeight) {
				elCalScroll.height(scrHeight + (sidHeight - calHeight));
			} else if (calHeight > sidHeight) {
				if (sidHeight > this.innerHeight - navHeight) {
					elCalScroll.height(scrHeight + (sidHeight - calHeight));
				} else {
					elCalScroll.height(minScrollHeight);
				}
			}
		} else {
			setTimeout(() => {
				this.changeCalendarHeight(event, ++count);
			}, 300);
		}
	}

	// Set elements size and position.
	public windowResized(): void {
		// Verify if is a mobile like device.
		this.isMobile = this.global.isMobileDevice();
		// Header positions.
		this.positionCalendarHeader();
	}

	// Set positions of calendar header elements.
	public positionCalendarHeader(isFirst = false): void {
		// Get elements.
		const elCalendar = $('#calendar-content');
		const elHeader = $('.schedule-header');
		const elSearch = $('.header-search');
		const elSearchInput = $('.header-search input');
		const elNav = $('.header-nav');
		const elRight = $('.header-right');
		const elSelect = $('select.selectMode');
		const elButtonNew = $('button.btnNewSession');
		// Sizes.
		const elCalendarW: number = elCalendar.width();
		const elSearchW: number = elSearch.width();
		const elRightW: number = elRight.width();
		const elNavMin = 330;
		const elSearchInputDef = 236;
		const elButtonNewW: number = elButtonNew.width();
		// Groups.
		const searchAndRightW: number = elSearchInputDef + elRightW + 20;
		const navSlot: number = elCalendarW - searchAndRightW;
		// Positions.
		if (navSlot < elNavMin) {
			// Navigation bar goes to new line.
			elHeader.css('height', '60px');
			elNav.css('margin-left', '0');
			elNav.css('margin-top', '50px');
			elNav.css('width', elCalendarW);
			$('active-period').css('font-size', '14px');
			// Search input sizes and positions.
			if (this.innerWidth > 500) {
				const newInputW: number = elCalendarW - elRightW - 50;
				elSearchInput.css('width', newInputW);
			} else {
				elSearch.hide();
				elSelect.css('width', elCalendarW - elButtonNewW - 80);
			}
		} else {
			elSearch.show();
			elSelect.css('width', 'auto');
			// Navigation bar at same line.
			const newNavW: number = isFirst ? 250 : elSearchW + 10;
			elHeader.css('height', 'auto');
			elNav.css('width', navSlot);
			elNav.css('margin-left', newNavW);
			elNav.css('margin-top', '-15px');
			$('span.active-period').css('font-size', '20px');
			elSearchInput.css('width', elSearchInputDef);
		}
		if (isFirst) {
			setTimeout(() => {
				this.positionCalendarHeader(false);
			}, 400);
		}
	}

	// Show calendars page on mobile.
	public showMobileCalendars(): void {
		this.mobileMode = EMobileMode.Calendar;
		this.buildActiveDate();
	}

	// Show events of a day on mobile.
	public showMobileDayEvents(date: Date): void {
		this.mobileMode = EMobileMode.Details;
		this.buildActiveDate(date);
	}

	// Show search result on mobile.
	public showMobileSearch(search: any): void {
		if (search) {
			this.mobileMode = EMobileMode.Search;
			this.searchValue = search.query;
		}
	}

	// When search is completed.
	public searchComplete(): void {
		$('.ui-autocomplete-loader').hide();
	}

	// Go to appointments page.
	public manageAppointments(): void {
		this.router.navigate(['/appointments']);
	}

	private getBoundariesDates() {
		let minDate: moment.Moment, maxDate: moment.Moment;
		switch (this.selectedMode) {
			case 'Month':
				minDate = moment.utc(this.activeDate.date).startOf('month');
				maxDate = moment.utc(this.activeDate.date).endOf('month');
				break;
			case 'Day':
				minDate = moment.utc(this.activeDate.date).startOf('day');
				maxDate = moment.utc(this.activeDate.date).endOf('day');
				break;
			case 'Week':
			default:
				minDate = moment.utc(this.activeDate.date).startOf('week');
				maxDate = moment.utc(this.activeDate.date).endOf('week');
				break;
		}
		return { minDate, maxDate };
	}

	closeWelcomeModal(): void {
		this.welcomeModalOpen = false;
		localStorage.setItem('viewedWelcomeModal', 'true');
	}
}
